import { applySpec, propOr } from 'ramda';

const ExternalReferrer = applySpec({
  referrerId: propOr('', 'referrerId'),
  referrerLink: propOr('', 'referrerLink'),
  referrerName: propOr('', 'referrerName'),
  referrerType: propOr('', 'referrerType'),
  referrerURL: propOr('', 'referrerURL'),
});

export default ExternalReferrer;
